import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { getVarsomeHost } from "../../../../../../state/selectors/general.selectors";

const VariantColumn = ({ variant, varsomeHost }) => {
  if (variant && variant.length > 0) {
    return (
      <>
        {variant.map((variantObj, i) => {
          const url = variantObj.variant_ids?.[0]
            ? `${varsomeHost}/variant/${variantObj.variant_ids?.[0]}`
            : null;
          return (
            <div key={i} className="tw-mb-0">
              <span className="tw-mr-1">
                {url ? (
                  <a href={url}>{`${variantObj.gene} ${variantObj.hgvs}`}</a>
                ) : (
                  `${variantObj.gene} ${variantObj.hgvs}`
                )}
              </span>
            </div>
          );
        })}
      </>
    );
  }
  return "-";
};

VariantColumn.propTypes = {
  variant: PropTypes.arrayOf(PropTypes.shape({})),
  varsomeHost: PropTypes.string,
};

VariantColumn.defaultProps = {
  variant: [],
  varsomeHost: "",
};

const mapStateToProps = (state) => ({
  varsomeHost: getVarsomeHost(state),
});

export default connect(mapStateToProps, {})(VariantColumn);
